// extracted by mini-css-extract-plugin
module.exports = {"arrowLeft":"ArrowLeft_arrowLeft__EezbE","arrow":"ArrowLeft_arrow__vZfzP"};